module.exports = __webpack_public_path__ + "static/Secondary-bath-mobile-c6fce97bdda61b7638d0d37bb35f4a42.jpg";